// Helper function (e.g., in a utils.js or at the top of the relevant component file)
export const getBaseComment = (commentString, weightValue) => {
  if (!commentString) {
    return ""
  }
  let tempComment = String(commentString) // Ensure it's a string

  // Regex 1: Attempt to strip " | XX.YY kg" (more specific, preferred pattern)
  // Handles optional spaces around "|", number, and "kg". Case-insensitive for "kg".
  const specificWeightRegex = new RegExp(`\\s*\\|\\s*${Number(weightValue).toFixed(2)}\\s*kg$`, "i")
  tempComment = tempComment.replace(specificWeightRegex, "").trim()

  // Regex 2: Attempt to strip just "XX.YY kg" if it's at the end of the string
  // This is more general for cases where the pipe might be missing.
  // Ensure weightValue is properly escaped if it could contain regex special characters (unlikely for numbers).
  const generalWeightRegex = new RegExp(`\\s*${Number(weightValue).toFixed(2)}\\s*kg$`, "i")
  tempComment = tempComment.replace(generalWeightRegex, "").trim()

  // Regex 3: Attempt to strip " | Anything ending in kg" if weightValue isn't exact or known
  // This is broader.
  const pipeAndKgRegex = /\s*\|\s*.*kg$/i
  tempComment = tempComment.replace(pipeAndKgRegex, "").trim()

  // Regex 4: Attempt to strip anything ending in "kg" if it seems to be only weight
  // This is very broad and should be used cautiously or refined
  // For example, if the original comment was "Product ABC is 10kg", we don't want to strip "10kg"
  // This regex is more for when the comment seems to be *only* a weight declaration or similar.
  // A simple check: if tempComment after other replacements *still* looks like just a weight.
  if (/^[\d\.]+\s*kg$/i.test(tempComment)) {
    // If the remaining comment is JUST "XX.YY kg"
    return "" // Consider it as only weight, so base comment is empty
  }

  return tempComment
}
